import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import BaseFeature from './BaseFeature';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';

const FSET_EN = "fset.en";

class FadeSettings extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[FSET_EN].value === "1" ? true : false
        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };

        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === FSET_EN) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    render() {
        const fsetEn = this.props.properties[FSET_EN];
        const fsetFt = this.props.properties["fset.ft"];

        return (
            <><Row>
                <Col sm={3} style={{minWidth: '400px'}}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            {this.props.feature.displayName}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertySwitch
                                property={fsetEn}
                                title={fsetEn.info.displayName}
                                handleChange={this.handleChange} />

                            <PropertyPicker
                                disabled={!this.state.isEnabled}
                                property={fsetFt}
                                title={fsetFt.info.displayName + ` (${fsetFt.info.unit})`}
                                margin="0.75rem auto"
                                inputPadding={'padding-none'}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                titleSize={6}
                                inputSize={6}
                                min={fsetFt.valueMeta.min}
                                max={fsetFt.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(FadeSettings);
